import { Injectable } from '@angular/core';
import { PreCheckoutStore } from './pre-checkout.store';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  constructor(private store: PreCheckoutStore) {}

  updateCpf = (cpf: string) => this.store.update({cpf});
  updateName = (name: string) => this.store.update({name});
  updatePhone = (phone: string) => this.store.update({phone});
  updateRoute = (route: string) => this.store.update({route});
  updateSm = (sm: string) => this.store.update({sm});
  updateOriginCd = (originCd: string) => this.store.update({originCd});
  updateDestinoCd = (destinoCd: string) => this.store.update({destinoCd});
  updateTransporter = (transporter: string) => this.store.update({transporter});
  updateTransporterType = (transporterType: string) => this.store.update({transporterType});
  updateHash = (hash: string) => this.store.update({hash});
  updatePlates = (plates: Array<any>) => this.store.update({plates});
  updateStageLogin = (stageLogin: boolean) => this.store.update({stageLogin});
  updateStageViagem = (stageViagem: boolean) => this.store.update({stageViagem});
  updateStageVeiculo = (stageVeiculo: boolean) => this.store.update({stageVeiculo});
}